"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
const react_1 = __importDefault(require("react"));
const pagination_styled_1 = require("./pagination.styled");
const vobaza_ui_icon_1 = require("@nebo-team-dev/vobaza.ui.icon");
function Pagination(_a) {
    var { pageCount, activePage, onChange, className = '', variation = 'primary' } = _a, props = __rest(_a, ["pageCount", "activePage", "onChange", "className", "variation"]);
    const getPageNumbersRange = () => {
        const range = [];
        const offset = variation === 'primary' ? 5 : 2;
        let start = activePage - offset;
        let end = activePage + offset;
        if (pageCount <= 10) {
            start = 1;
            end = pageCount;
        }
        // Ограничение диапазона
        if (start < 1) {
            end += 0 - start;
            start = 1;
        }
        else if (end > pageCount) {
            start -= end - pageCount;
            end = pageCount;
        }
        // Добавление левой части
        if (start > 1) {
            range.push(1);
            if (start - 1 > 1)
                range.push(null);
        }
        for (let i = start; i <= end; i++) {
            range.push(i);
        }
        // Добавление правой части
        if (end < pageCount) {
            if (end + 1 < pageCount)
                range.push(null);
            range.push(pageCount);
        }
        return range;
    };
    const prevPage = () => {
        if (onChange) {
            onChange(activePage - 1);
        }
    };
    const onClickPageNumber = (pageNumber) => {
        if (pageNumber && onChange) {
            onChange(pageNumber);
        }
    };
    const nextPage = () => {
        if (onChange) {
            onChange(activePage + 1);
        }
    };
    return (react_1.default.createElement(pagination_styled_1.StyledPaginationContainer, Object.assign({ className: className }, props, { "data-variation": variation }),
        variation === 'secondary' && (react_1.default.createElement(pagination_styled_1.StyledPaginationItem, { className: `item--number prev ${activePage === 1 ? 'disabled' : ''}`, "data-variation": variation, onClick: prevPage },
            react_1.default.createElement(vobaza_ui_icon_1.Icon, { name: "SmallArrowRight" }))),
        getPageNumbersRange().map((pageNumber, index) => {
            const className = [
                pageNumber ? 'item--number' : 'item--points',
                activePage === pageNumber ? 'active' : '',
            ];
            return (react_1.default.createElement(pagination_styled_1.StyledPaginationItem, { key: `${pageNumber}-${index}`, className: className.join(' '), "data-variation": variation, onClick: () => onClickPageNumber(pageNumber) }, pageNumber ? pageNumber : '...'));
        }),
        variation === 'secondary' && (react_1.default.createElement(pagination_styled_1.StyledPaginationItem, { className: `item--number ${activePage === pageCount ? 'disabled' : ''}`, "data-variation": variation, onClick: nextPage },
            react_1.default.createElement(vobaza_ui_icon_1.Icon, { name: "SmallArrowRight" })))));
}
exports.Pagination = Pagination;
//# sourceMappingURL=pagination.js.map